import { forwardRef, useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { formatDate, getImageUrl } from "src/Common/common";

const DateTrigger = forwardRef(({ value, onClick }, ref) => (
  <span
    ref={ref}
    onClick={onClick}
    className="text-[14px] font-OpenSansRegular font-[700] text-titleColor cursor-pointer"
  >
    {value}
  </span>
));

const hasLoggedTime = (entry) => {
  const isNonZero = (v) => v && typeof v === "string" && v.trim() !== "" && v.trim() !== "00:00" && v.trim() !== "__:__";
  return isNonZero(entry.regularTime) || isNonZero(entry.travelTime) || isNonZero(entry.overTime);
};

const DayIndicator = ({ startDateString, viewMode, currentDateChanged, timesheetData }) => {
  const [endDate] = useState(new Date());
  const [currentDate, setCurrentDate] = useState(new Date());
  const minDate = startDateString ? new Date(startDateString) : null;
  const toStartOfDay = (date) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const highlightDates = useMemo(() => {
    if (!timesheetData || !startDateString) return [];
    const startDate = new Date(startDateString);
    const dateSet = new Set();
    for (const tech of timesheetData) {
      if (!tech.timesheet) continue;
      for (const entry of tech.timesheet) {
        if (hasLoggedTime(entry)) {
          const d = new Date(startDate);
          d.setDate(d.getDate() + Number(entry.dayDiff || 0));
          dateSet.add(d.toDateString());
        }
      }
    }
    return Array.from(dateSet).map((ds) => new Date(ds));
  }, [timesheetData, startDateString]);

  const handlePreviousDate = () => {
    const previousDate = new Date(currentDate);
    previousDate.setDate(previousDate.getDate() - 1);

    if (minDate && toStartOfDay(previousDate) < toStartOfDay(minDate)) return;

    setCurrentDate(previousDate);
  };

  const handleNextDate = () => {
    const nextDate = new Date(currentDate);
    nextDate.setDate(nextDate.getDate() + 1);

    if (toStartOfDay(nextDate) > toStartOfDay(endDate)) return;

    setCurrentDate(nextDate);
  };

  useEffect(() => {
    currentDateChanged(currentDate);
  }, [currentDate]);

  return (
    <div>
      {viewMode === "total" ?
        <span className="text-[14px] font-OpenSansRegular font-[700] text-titleColor">{startDateString} - {formatDate(endDate, "MM/DD/YYYY")}</span>
        : viewMode === "day" ? <div data-tour="ts-date" className="flex items-center justify-center">
          <img onClick={handlePreviousDate} src={getImageUrl("/images/common/previous-arrow.png")} className="w-[24px] h-[24px] cursor-pointer mr-5" />
          <DatePicker
            selected={currentDate}
            onChange={(date) => date && setCurrentDate(date)}
            dateFormat="MM/dd/yyyy"
            minDate={minDate}
            maxDate={endDate}
            customInput={<DateTrigger />}
            highlightDates={highlightDates}
          />
          <img onClick={handleNextDate} src={getImageUrl("/images/common/next-arrow.png")} className="w-[24px] h-[24px] cursor-pointer ml-5" />
        </div> : null}
    </div>
  );
};

export default DayIndicator;